import { useAuth } from "@/context/AuthContext";

// Define admin roles
const ADMIN_ROLES = ["admin", "superadmin"];

export function useAdminAccess() {
  const { user } = useAuth();
  const userRole = user?.role || "guest";
  const isAdmin = ADMIN_ROLES.includes(userRole);
  const isSuperAdmin = userRole === "superadmin";

  // Remove the console log
  // if (import.meta.env.DEV) {
  //   console.log("Admin access check:", {
  //     user: user?.name,
  //     userRole,
  //     isAdmin,
  //     isSuperAdmin,
  //     userId: user?.id,
  //   });
  // }

  return {
    isAdmin,
    isSuperAdmin,
    user,
  };
}
